import axios from "axios";

const api = axios.create({
  baseURL:
    process.env.REACT_APP_STATE === "production"
      ? "https://safebridge.urbanpillar.com/api/"
      : process.env.REACT_APP_STATE === "testing"
      ? "https://safetest.urbanpillar.com/api/"
      : `http://${window.location.hostname}:8000/api/`,
});

if (process.env.REACT_APP_STATE === "production") {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
}

console.log(process.env.REACT_APP_STATE);
export default api;
